<template>
    <div class="price-note text-caption text--secondary">{{ touristsTotal }} {{ $t(touristLabel, touristsTotal) }}</div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class PriceNote extends Vue {
        @Prop({required: true}) searchRequest
        @Prop({default: 'guest'}) touristLabel

        get touristsTotal() {
            return this.searchRequest.adults + this.searchRequest.childrenAges.length
        }
    }

    export default PriceNote
</script>
